export default __webpack_public_path__ + "/dist/images/icon-ai.663be1f928e2f4bcc5c174bd683202e1.png";